const firebaseConfig = {
    apiKey: "AIzaSyDrEP9XVBXYtEmsrikxGr3bvXnDgeuUBt0",
    authDomain: "simple-firebase-auth-1f633.firebaseapp.com",
    projectId: "simple-firebase-auth-1f633",
    storageBucket: "simple-firebase-auth-1f633.appspot.com",
    messagingSenderId: "115783445778",
    appId: "1:115783445778:web:17c6d04e24fe07febfd7cb"
  };

  export default firebaseConfig;